import type { PedaCategoryKey } from './peda-categories';
import { apiFetch } from './api-client';

export interface RecordPedaEventParams {
  scenarioId: string;
  missionId?: string | null;
  sceneId: string;
  pedaCategory: PedaCategoryKey;
  correct: boolean;
}

export function recordPedaEvent(params: RecordPedaEventParams): void {
  const { scenarioId, missionId, sceneId, pedaCategory, correct } = params;

  void apiFetch('/api/stats/peda-event', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      scenario_id: scenarioId,
      mission_id: missionId ?? null,
      scene_id: sceneId,
      peda_category: pedaCategory,
      correct,
    }),
  }).catch(() => {
    // Fire-and-forget: gameplay must not block on analytics.
  });
}
